<script setup>
import TabItem from "@/components/global-themed/tabs/TabItem.vue";
import TabContainer from "@/components/global-themed/tabs/TabContainer.vue";
import {useStore} from "vuex";
import useOpportunityStore from "@/composables/backlinks/opportunity/useOpportunityStore";
import {getBacklinkOpportunities} from "@/composables/backlinks/opportunity/useBacklinkOpportunity";

const store = useStore();

const { activeTab, activeCompetitor } = useOpportunityStore();

const {isLoading} = getBacklinkOpportunities(activeTab, activeCompetitor);

const changeTab = (type) => {
  if (isLoading.value) {
    return;
  }

  store.dispatch('backlinkOpportunity/setActiveTab', type)
}
const tabs = [
  {
    key: 'opportunities',
    text: 'Opportunities',
    icon: 'stars',
  },
  {
    key: 'in-progress',
    text: 'In Progress',
    icon: 'retry',
  },
  {
    key: 'completed',
    text: 'Completed',
    icon: 'check-circle-thin',
  },
  {
    key: 'removed',
    text: 'Removed',
    icon: 'trash-thin',
  },
]
</script>

<template>
  <TabContainer>
    <TabItem
      v-for="{key, text, icon} in tabs"
      :key="key"
      :active="activeTab === key"
      class="tw-flex tw-items-center tw-justify-center tw-space-x-3"
      :class="{
        'tw-pointer-events-none' : isLoading,
      }"
      @click="changeTab(key)"
    >
      <svg-vue
        :icon="`icons/${icon}`"
        class="tw-w-6 tw-h-6"
        :class="{'tw-text-grey': activeTab === key}"
      />
      <span class="tw-font-bold">{{ text }}</span>
    </TabItem>
  </TabContainer>
</template>
